import React from 'react';

import { Button, Modal, Spin } from 'antd';

interface IProps {
  title?: string;
  buttonOk?: string;
  buttonOkColor?: string;
  buttonCancel?: string;
  open: boolean;
  onClose: () => void;
  onOk: () => void;
  loading?: boolean;
  loadingColor?: string;
  buttonOkDisabled?: boolean;
  children?: React.ReactNode;
}

const ModalActions: React.FC<IProps> = ({
  title,
  buttonOk,
  buttonOkColor,
  buttonCancel,
  open,
  onClose,
  onOk,
  loading,
  loadingColor,
  buttonOkDisabled,
  children
}) => {
  return (
    <Modal
      open={open}
      title={title ?? 'Deseja realmente executar esta ação?'}
      onCancel={onClose}
      width={444}
      footer={
        <div className='flex justify-end gap-2'>
          <Button type='text' onClick={onClose} className='mb-2' disabled={loading}>
            {buttonCancel || 'Cancelar'}
          </Button>
          <Button
            type='primary'
            onClick={onOk}
            style={{ marginBottom: '0.5rem', background: buttonOkColor }}
            disabled={loading || buttonOkDisabled}
            id='modal-button-confirm'
          >
            {buttonOk || 'Ok'}
            {loading && <Spin size='small' className='ml-3' style={{ color: loadingColor || '#ccc' }} />}
          </Button>
        </div>
      }
      destroyOnHidden={true}
    >
      <p className='text-gray-500'>{children}</p>
    </Modal>
  );
};

export default ModalActions;
